import React from 'react';
import { Provider } from 'react-redux';

import configureStore from '../store/appMenuStore';
import AppMenuContainer from '../containers/AppMenuContainer';
import AppMenuV2 from '../components/AppMenuV2';

const AppMenuApp = (props) => (
  props.navigationV2
    ? <AppMenuV2 {...props} />
    : (
      <Provider store={configureStore(props)}>
        <AppMenuContainer />
      </Provider>
    )
);

export default AppMenuApp;
